// A date-only value ("2026-10-20", or the same day sent as midnight UTC) is a calendar day. new Date("2026-10-20")
// reads it as midnight UTC, which is still the day before anywhere in the Americas, so a receipt dated the 20th
// showed the 19th (FH-226). These read it as that day in the browser's own calendar instead.
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})(?:$|T00:00(?::00(?:\.0+)?)?(?:Z|[+-]00:?00)?$)/;

/** The value as a Date at local midnight of its calendar day, or null when it isn't a date. */
export function parseDateOnly(value) {
  if (value === null || value === undefined || value === '') return null;
  const match = DATE_ONLY.exec(String(value));
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** The value shown as a date in the user's locale, without moving it to another day. */
export function formatDateOnly(value) {
  const date = parseDateOnly(value);
  return date ? date.toLocaleDateString() : (value === null || value === undefined ? '' : String(value));
}
